import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Spinner } from './components/Loading';
import './styles/global.css';

// Lazy load views for optimal bundle splitting
const CatalogView = lazy(() => import('./views/CatalogView'));
const DraftReviewView = lazy(() => import('./views/DraftReviewView'));
const FulfillmentView = lazy(() => import('./views/FulfillmentView'));
const AdminView = lazy(() => import('./views/AdminView'));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Spinner text="Loading..." />}>
        <Routes>
          {/* Public: Customer Catalog */}
          <Route path="/" element={<CatalogView />} />

          {/* Draft Review: Admin clicks WhatsApp link */}
          <Route path="/draft/:draftId" element={<DraftReviewView />} />

          {/* Fulfillment: Staff packing view */}
          <Route path="/fulfill/:orderId" element={<FulfillmentView />} />

          {/* Admin: Secure product management */}
          <Route path="/admin" element={<AdminView />} />

          {/* Fallback */}
          <Route path="*" element={
            <div style={{ padding: 40, textAlign: 'center' }}>
              <h2>Page not found</h2>
              <p style={{ marginTop: 8, color: '#6B6B8D' }}>
                <a href="/" style={{ color: '#00D4AA' }}>Go to Catalog</a>
              </p>
            </div>
          } />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
